import { render, staticRenderFns } from "./skipDetail.vue?vue&type=template&id=13ee6e06&"
import script from "./skipDetail.vue?vue&type=script&lang=js&"
export * from "./skipDetail.vue?vue&type=script&lang=js&"
import style0 from "./skipDetail.vue?vue&type=style&index=0&id=13ee6e06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports